import { useEffect } from 'react';
import { createLogger } from '@/lib/logger';
import { View, ActivityIndicator } from 'react-native';
import { Stack, useRouter } from 'expo-router';
import { useAuth } from '@/contexts/AuthContext';
import { useTheme } from '@/contexts/ThemeContext';

const log = createLogger('_LAYOUT');

export default function AuthLayout() {
  const router = useRouter();
  const { session, loading } = useAuth();
  const { theme } = useTheme();

  useEffect(() => {
    if (!loading && session) {
      if (__DEV__) {
        log.info('[AUTH_LAYOUT] User is authenticated, redirecting to /gate');
      }
      router.replace('/gate');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session, loading]);

  // Prevent flash of auth screens while checking session or when already authenticated
  if (loading || session) {
    return (
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: theme.colors.background }}>
        <ActivityIndicator size="large" color={theme.colors.accent} />
      </View>
    );
  }

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: theme.colors.background },
      }}>
      <Stack.Screen name="welcome" />
      <Stack.Screen name="signin" />
      <Stack.Screen name="signup" />
      <Stack.Screen name="check-email" />
    </Stack>
  );
}
